import * as z from 'zod'

export const GameShape = z.union([z.literal('Tipping'), z.literal('Picking')])
export type GameName = z.TypeOf<typeof GameShape>
